module.exports = __webpack_public_path__ + "static/media/8900_Sink.c46d088b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Sink.jpg
// module id = 582
// module chunks = 0